// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__respons__IVAVM {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.styles_headerTitle__Yby\\+q {
  margin-inline: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.styles_headerTitle__Yby\\+q h1 {
  font-family: "Abhaya Libre";
  font-size: calc(1rem + 0.8vw);
  color: #18316e;
  text-align: center;
  line-height: 1.3;
}

.styles_subtitle__header__36Mq\\+ {
  text-align: center;
  max-width: 750px;
  font-family: "inter";
  font-weight: 400;
  color: #18316e;
  font-size: calc(0.5rem + 0.35vw);
}

.styles_formContato__hD\\+Bc {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_formData__PNQuo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 894px;
  margin: 2rem;
  gap: 1rem;
}

.styles_clientData__xmw9a {
  justify-content: space-between;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.styles_clientData__line__CnAJ5 {
  width: 100%;
  display: flex;  
  gap: 1rem;
}

.styles_termo__AQHCp {
  display: flex;
  align-items: center;
}

.styles_spanText__34bBb {
  font-family: "inter";
  font-weight: 500;
  font-size: 0.7rem;
}

.styles_destaqueSpan__YxA5z {
  text-decoration: none;
  color: #18316e;
  margin-inline: 0.2rem;
  font-family: "inter";
  font-weight: 700;
  font-size: 0.7rem;
}

.styles_destaqueSpan__instru__Gjewe {
  text-decoration: none;
  color: #18316e;
  margin-inline: 0.2rem;
  font-family: "inter";
  font-weight: 700;
  font-size: 1rem;
}

.styles_buttonContainer__LMXNI {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-inline: 1rem;
}

.styles_productOptions__g15j4 {
  gap: 1rem;
  width: 750px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.styles_cardsContainer__ChtMh {
  width: 100%;
  display: flex;
  gap: 3.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.styles_cardContainer__front__KiELF {
  width: 280px;
  height: 325px;
  display: flex;
  justify-content: center;
}

.styles_cardContainer__back__j5nur {
  box-sizing: border-box;
  width: 280px;
  height: 325px;
  overflow-y: scroll;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #000;
  gap: 0.5rem;
  border-radius: 8px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.7);
}

.styles_buttonFlip__6Vf48 {
  font-size: 2rem !important;
  padding: 0;
  font-size: 2rem;
  border-radius: 50%;
  background: none;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border: none;
  bottom: 0.3rem;
  right: 0.3rem;
  color: #18316e;
  cursor: pointer;
}

.styles_buttonFlip__6Vf48:hover {
  background: none;
  cursor: pointer;
  border-radius: 50%;
  color: #4b6fc0;
}

.styles_cardContainer__cWQiu {
  border: 1px solid #000;
  width: 280px;
  height: 325px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  cursor: pointer;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.7);
}

.styles_cardContainer__cWQiu:hover::before {
  content: "";
  border-radius: 8px;
  position: absolute;
  background-color: #18316e;
  opacity: 0.1;
  width: 280px;
  height: 325px;
}

.styles_card__SREOc img {
  width: 278px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.styles_textContainer__rGEJX {
  margin-inline: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
}

.styles_productName__OTJAI {
  font-size: 1.5rem;
  font-family: "inter";
  font-weight: 600;
  color: #18316e;
  text-align: center;
}

.styles_productDescription__NeWFI {
  font-size: 0.8rem;
  font-family: "inter";
  font-weight: 400;
  color: #18316e;
}

.styles_separador__WZYbU {
  border: 1px solid #18316e;
}

.styles_separador__back__4AOig {
  border: 1px solid #18316e;
  width: 200px;
}

.styles_checkerCard__iVJU0 {
  display: none;
}

.styles_checkerCard__iVJU0:checked ~ .styles_card__SREOc::before {
  content: "";
  border-radius: 8px;
  position: absolute;
  background-color: #18316e;
  opacity: 0.3;
  width: 280px;
  height: 325px;
}

.styles_buttonSubmit__Sh6BC {
  text-transform: capitalize !important;
  background-color: #18316e !important;
  color: #fff !important;
  transition: all 0.3s ease-in-out !important;
}

.styles_buttonSubmit__Sh6BC:hover {
  transform: scale(0.9) !important;
}

@media (max-width: 748px) {
  .styles_formData__PNQuo {
    margin-inline: 0;
  }

  .styles_formData__PNQuo {
    max-width: 95vw;
  }

  .styles_headerTitle__Yby\\+q {
    justify-content: space-between;
    margin-inline: 0;
    margin-bottom: 2rem;
  }

  .styles_headerTitle__Yby\\+q h1 {
    text-align: left;
  }

  .styles_clientData__line__CnAJ5 {
    flex-direction: column;
  }

  .styles_subtitle__header__36Mq\\+ {
    width: 70vw;
    font-size: calc(0.8rem + 0.35vw);
    text-align: left;
  }

  .styles_productOptions__g15j4 {
    width: 300px;
  }

  .styles_buttonContainer__LMXNI {
    justify-content: center;
  }

  .styles_buttonSubmit__Sh6BC {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SugestaoDeServicos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".container__respons {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.headerTitle {\n  margin-inline: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.headerTitle h1 {\n  font-family: \"Abhaya Libre\";\n  font-size: calc(1rem + 0.8vw);\n  color: #18316e;\n  text-align: center;\n  line-height: 1.3;\n}\n\n.subtitle__header {\n  text-align: center;\n  max-width: 750px;\n  font-family: \"inter\";\n  font-weight: 400;\n  color: #18316e;\n  font-size: calc(0.5rem + 0.35vw);\n}\n\n.formContato {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.formData {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 894px;\n  margin: 2rem;\n  gap: 1rem;\n}\n\n.clientData {\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.clientData__line {\n  width: 100%;\n  display: flex;  \n  gap: 1rem;\n}\n\n.termo {\n  display: flex;\n  align-items: center;\n}\n\n.spanText {\n  font-family: \"inter\";\n  font-weight: 500;\n  font-size: 0.7rem;\n}\n\n.destaqueSpan {\n  text-decoration: none;\n  color: #18316e;\n  margin-inline: 0.2rem;\n  font-family: \"inter\";\n  font-weight: 700;\n  font-size: 0.7rem;\n}\n\n.destaqueSpan__instru {\n  text-decoration: none;\n  color: #18316e;\n  margin-inline: 0.2rem;\n  font-family: \"inter\";\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.buttonContainer {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding-inline: 1rem;\n}\n\n.productOptions {\n  gap: 1rem;\n  width: 750px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.cardsContainer {\n  width: 100%;\n  display: flex;\n  gap: 3.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.cardContainer__front {\n  width: 280px;\n  height: 325px;\n  display: flex;\n  justify-content: center;\n}\n\n.cardContainer__back {\n  box-sizing: border-box;\n  width: 280px;\n  height: 325px;\n  overflow-y: scroll;\n  padding: 0.8rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid #000;\n  gap: 0.5rem;\n  border-radius: 8px;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.7);\n}\n\n.buttonFlip {\n  font-size: 2rem !important;\n  padding: 0;\n  font-size: 2rem;\n  border-radius: 50%;\n  background: none;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  bottom: 0.3rem;\n  right: 0.3rem;\n  color: #18316e;\n  cursor: pointer;\n}\n\n.buttonFlip:hover {\n  background: none;\n  cursor: pointer;\n  border-radius: 50%;\n  color: #4b6fc0;\n}\n\n.cardContainer {\n  border: 1px solid #000;\n  width: 280px;\n  height: 325px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  cursor: pointer;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.7);\n}\n\n.cardContainer:hover::before {\n  content: \"\";\n  border-radius: 8px;\n  position: absolute;\n  background-color: #18316e;\n  opacity: 0.1;\n  width: 280px;\n  height: 325px;\n}\n\n.card img {\n  width: 278px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.textContainer {\n  margin-inline: 0.8rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.productName {\n  font-size: 1.5rem;\n  font-family: \"inter\";\n  font-weight: 600;\n  color: #18316e;\n  text-align: center;\n}\n\n.productDescription {\n  font-size: 0.8rem;\n  font-family: \"inter\";\n  font-weight: 400;\n  color: #18316e;\n}\n\n.separador {\n  border: 1px solid #18316e;\n}\n\n.separador__back {\n  border: 1px solid #18316e;\n  width: 200px;\n}\n\n.checkerCard {\n  display: none;\n}\n\n.checkerCard:checked ~ .card::before {\n  content: \"\";\n  border-radius: 8px;\n  position: absolute;\n  background-color: #18316e;\n  opacity: 0.3;\n  width: 280px;\n  height: 325px;\n}\n\n.buttonSubmit {\n  text-transform: capitalize !important;\n  background-color: #18316e !important;\n  color: #fff !important;\n  transition: all 0.3s ease-in-out !important;\n}\n\n.buttonSubmit:hover {\n  transform: scale(0.9) !important;\n}\n\n@media (max-width: 748px) {\n  .formData {\n    margin-inline: 0;\n  }\n\n  .formData {\n    max-width: 95vw;\n  }\n\n  .headerTitle {\n    justify-content: space-between;\n    margin-inline: 0;\n    margin-bottom: 2rem;\n  }\n\n  .headerTitle h1 {\n    text-align: left;\n  }\n\n  .clientData__line {\n    flex-direction: column;\n  }\n\n  .subtitle__header {\n    width: 70vw;\n    font-size: calc(0.8rem + 0.35vw);\n    text-align: left;\n  }\n\n  .productOptions {\n    width: 300px;\n  }\n\n  .buttonContainer {\n    justify-content: center;\n  }\n\n  .buttonSubmit {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container__respons": `styles_container__respons__IVAVM`,
	"headerTitle": `styles_headerTitle__Yby+q`,
	"subtitle__header": `styles_subtitle__header__36Mq+`,
	"formContato": `styles_formContato__hD+Bc`,
	"formData": `styles_formData__PNQuo`,
	"clientData": `styles_clientData__xmw9a`,
	"clientData__line": `styles_clientData__line__CnAJ5`,
	"termo": `styles_termo__AQHCp`,
	"spanText": `styles_spanText__34bBb`,
	"destaqueSpan": `styles_destaqueSpan__YxA5z`,
	"destaqueSpan__instru": `styles_destaqueSpan__instru__Gjewe`,
	"buttonContainer": `styles_buttonContainer__LMXNI`,
	"productOptions": `styles_productOptions__g15j4`,
	"cardsContainer": `styles_cardsContainer__ChtMh`,
	"cardContainer__front": `styles_cardContainer__front__KiELF`,
	"cardContainer__back": `styles_cardContainer__back__j5nur`,
	"buttonFlip": `styles_buttonFlip__6Vf48`,
	"cardContainer": `styles_cardContainer__cWQiu`,
	"card": `styles_card__SREOc`,
	"textContainer": `styles_textContainer__rGEJX`,
	"productName": `styles_productName__OTJAI`,
	"productDescription": `styles_productDescription__NeWFI`,
	"separador": `styles_separador__WZYbU`,
	"separador__back": `styles_separador__back__4AOig`,
	"checkerCard": `styles_checkerCard__iVJU0`,
	"buttonSubmit": `styles_buttonSubmit__Sh6BC`
};
export default ___CSS_LOADER_EXPORT___;
